import $ from 'jquery';
import eventProxy from '@/scripts/tools/eventProxy';

$(document.body).on('keydown', e => {
  if (e.target.tagName !== 'INPUT' && e.target.tagName !== 'TEXTAREA') {
    if ((e.ctrlKey || e.metaKey) && e.keyCode === 65 && e.target === document.body) {
      eventProxy.emit('command.select-all');
      e.preventDefault();
    } else if (e.keyCode === 46) {
      // Del
      eventProxy.emit('command.delete');
    }
  }
});

const isEditAble = function isEditAble(el) {
  return (
    el.tagName === 'TEXTAREA'
    || (el.tagName === 'INPUT' && ['text', 'password', 'number', 'url', 'search', 'email'].includes(el.type))
    || el.isContentEditable
  );
};
$(document.body).on('copy', e => {
  // !$('.dialog__container').is(':visible') :过滤如果界面有弹窗时，不允许复制的情况
  !isEditAble(e.target) && !$('.dialog__container').is(':visible') && eventProxy.emit('command.copy');
});
$(document.body).on('paste', e => {
  // console.log(e.target, isEditAble(e.target));
  !isEditAble(e.target) && eventProxy.emit('command.paste');
});
